import { useCallback, useState } from 'react';

import { SystemMessageType } from '../types/componentType';

type SystemMessageType = 'error' | 'success' | 'warning' | 'info';

interface SystemMessageManager {
  showMessage: (message: string | string[], type: SystemMessageType) => void;
  hideMessage: () => void;
  message: string | string[];
  type: SystemMessageType;
  show: boolean;
}

/**
 * Hook to manage system messages
 * 
 * @returns SystemMessageManager - Object with functions and state to manage messages
 */
export const useSystemMessage = (): SystemMessageManager => {
  const [message, setMessage] = useState<string | string[]>('');
  const [type, setType] = useState<SystemMessageType>('info');
  const [show, setShow] = useState<boolean>(false);

  const showMessage = useCallback((newMessage: string | string[], messageType: SystemMessageType) => {
    setMessage(newMessage);
    setType(messageType);
    // Reset show to force remount and transition false → true in BsdsToast
    setShow(false);
    requestAnimationFrame(() => {
      setShow(true);
    });
  }, []);

  const hideMessage = useCallback(() => {
    setShow(false);
  }, []);

  return {
    showMessage,
    hideMessage,
    message,
    type,
    show
  };
};
